module.exports = __webpack_public_path__ + "img/Banner-HomeModel-dwnszd.395279ec.jpg";